var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomSave = function SvgCustomSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8c0-2.828 0-4.243.879-5.121C3.757 2 5.172 2 8 2h7.899c.817 0 1.226 0 1.594.152.367.152.656.442 1.234 1.02l2.101 2.1c.579.579.867.868 1.02 1.236C22 6.875 22 7.284 22 8.1V16c0 2.828 0 4.243-.879 5.121-.714.715-1.782.848-3.677.873v-3.722c0-.654 0-1.242-.063-1.718-.07-.52-.232-1.052-.669-1.488-.436-.437-.969-.599-1.488-.669-.476-.064-1.064-.064-1.718-.064H9.383c-.654 0-1.242 0-1.718.064-.52.07-1.052.232-1.488.669-.437.436-.599.969-.669 1.488-.064.476-.064 1.064-.064 1.718v3.686c-1.225-.073-2.004-.276-2.565-.837C2 20.243 2 18.828 2 16V8Zm13.444 10.333V22h-8v-3.667c0-.735.003-1.186.046-1.512.039-.287.094-.335.1-.34v-.001h.001c.006-.007.054-.062.34-.1.327-.044.778-.047 1.513-.047h4c.736 0 1.187.003 1.513.046.287.039.335.094.34.1h.001v.001c.007.006.062.054.1.34.044.327.046.778.046 1.513Zm-9-11.777a1 1 0 1 0 0 2H12a1 1 0 1 0 0-2H6.444Z",
    fill: "currentColor"
  })));
};

export default SvgCustomSave;